import { useState } from "react";
import Card from "../card/Card";
import ProjectModal from "./ProjectModal";
import "./Portfolio.css";
import { PortfolioData } from "../../parseJson";
import useInView from "../../hooks/useInView";

function Portfolio() {
  const [portfolioNav, handlePortNav] = useState(
    PortfolioData.projects[PortfolioData.active].data
  );
  const [portfolioActive, handlePortflioActive] = useState(
    PortfolioData.active
  );
  const [selectedProject, setSelectedProject] = useState(null);
  const [ref, isVisible] = useInView(0.2); // Triggers at 20% view

  return (
    <div className="portfolio main-section container-fluid" id="portfolio">
      <div
        ref={ref}
        className={`container reveal-animation ${isVisible ? "visible" : ""}`}
      >
        <div className="row justify-content-center">
          <div className="col-12 text-align-center">
            <div className="heading-container">
              <p className="heading-subtitle">{PortfolioData.subtitle}</p>
              <h2 className="heading-title">{PortfolioData.title}</h2>
            </div>
          </div>
        </div>
        <div className="main-section-content row">
          <div className="col-12">
            <ul className="list-inline project-nav">
              {Object.keys(PortfolioData.projects).map((project, index) => {
                return (
                  <li
                    className={
                      "list-inline-item project-nav-item " +
                      (project === portfolioActive ? "highlight" : "")
                    }
                    onClick={() => {
                      handlePortflioActive(project);
                      handlePortNav(PortfolioData.projects[project].data);
                    }}
                    key={index}
                  >
                    {PortfolioData.projects[project].title}
                  </li>
                );
              })}
            </ul>
          </div>

          <div 
            className="row"
            key={portfolioActive}
          >
            {portfolioNav.map((project, index) => {
              return (
                <div 
                  className="col-12 mb-5 project-card-anim" 
                  key={index}
                  style={{ animationDelay: `${index * 0.15}s` }}
                >
                  <Card 
                    data={project} 
                    reversed={index % 2 !== 0}
                    onClick={() => setSelectedProject(project)}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
      
      {selectedProject && (
        <ProjectModal 
          project={selectedProject} 
          onClose={() => setSelectedProject(null)} 
        />
      )}
    </div>
  );
}

export default Portfolio;
